import React, { useMemo } from 'react';
import {
  View,
  Text,
  FlatList,
  ScrollView,
  useWindowDimensions,
} from 'react-native';
import CustomPressable from '../customPressable/customPressable';
import { useCssStyle } from '../../customHook/getCssStyle';
import useWidgetClickHandler from '../../customHook/useWidgetClickHandler';
import HeaderWithBack from '../Header/headerWithBack';
import { ImageComp } from '../Image/Image';
import { CHEVRON_RIGHT } from '../../assets';
import CustomFlatList from '../customFlatList';
import RenderHTML from 'react-native-render-html';
import { getCleanUrl } from '../../utils/Helper';

const SubWidgetList = props => {
  const { route } = props || {};
  const { listItemData, widget } = route?.params || {};


  const { width } = useWindowDimensions();
  const getStyles = useCssStyle();

  // Use the custom hook to handle widget clicks
  const handleOnWidgetClick = useWidgetClickHandler();

  
  const renderItem = (item) => {
    const widgetImg = item?.widgetHeaderImageUrl ? getCleanUrl(item?.widgetHeaderImageUrl) : getCleanUrl(item?.btnImageUrl);
    
    const listItemDescription = getStyles(['list_itemContainer_textContainer_subtitle', 'subwidgetList_itemContainer_textContainer_subtitle', `subwidgetList_itemContainer_textContainer_subtitle_${item.widgetMetaHtmlId}`])
    return (

    <CustomPressable id={`list_itemContainer subwidgetList_itemContainer subwidgetList_itemContainer_${item.widgetMetaHtmlId}`} style={getStyles(['list_itemContainer', 'subwidgetList_itemContainer', `subwidgetList_itemContainer_${item.widgetMetaHtmlId}`])} onPress={() => handleOnWidgetClick(item)}>
      
      {item?.btnImageUrl && <ImageComp
        source={ widgetImg}
        style={getStyles(['list_itemContainer_image', 'subwidgetList_itemContainer_image', `subwidgetList_itemContainer_image_${item.widgetMetaHtmlId}`])}
        id={`list_itemContainer_image subwidgetList_itemContainer_image subwidgetList_itemContainer_image_${item.widgetMetaHtmlId}`}
        // resizeMode='cover'
      />}

      <View style={getStyles(['list_itemContainer_textContainer', 'subwidgetList_itemContainer_textContainer', `subwidgetList_itemContainer_textContainer_${item.widgetMetaHtmlId}`])} id={`list_itemContainer_textContainer subwidgetList_itemContainer_textContainer subwidgetList_itemContainer_textContainer_${item.widgetMetaHtmlId}`}>
        {item?.widgetTitle && 
          <Text 
            style={getStyles(['list_itemContainer_textContainer_title', 'subwidgetList_itemContainer_textContainer_title', `subwidgetList_itemContainer_textContainer_title_${item.widgetMetaHtmlId}`])} 
            id={`list_itemContainer_textContainer_title subwidgetList_itemContainer_textContainer_title subwidgetList_itemContainer_textContainer_title_${item.widgetMetaHtmlId}`} >
              {item.widgetTitle}
          </Text>}
        {item?.widgetDesc && 
         <RenderHTML
            contentWidth={width}
            baseStyle={listItemDescription}
            source={{ html: item?.widgetDesc }}
            systemFonts={[listItemDescription.fontFamily]}
            id={`list_itemContainer_textContainer_subtitle subwidgetList_itemContainer_textContainer_subtitle subwidgetList_itemContainer_textContainer_subtitle_${item.widgetMetaHtmlId}`}
          />
        }
      </View>

      <View style={getStyles(['list_itemContainer_arrow', 'subwidgetList_itemContainer_arrow', `subwidgetList_itemContainer_arrow_${item.widgetMetaHtmlId}`])} id={`list_itemContainer_arrow subwidgetList_itemContainer_arrow subwidgetList_itemContainer_arrow_${item.widgetMetaHtmlId}`}>
        <ImageComp source={CHEVRON_RIGHT} style={getStyles(['list_itemContainer_arrow_img'])}/>
      </View>
    </CustomPressable>
  )};


  const customWidgetTitleStyle = useMemo(() => {
    const style = getStyles(['widgetmainContainerHeaderTitle', 'subwidgetListHeaderTitle'])
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customWidgetDescStyle = useMemo(()=>{
    const style = getStyles(['widgetmainContainerHeaderSubTitle', "subwidgetListHeaderSubTitle"])
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderHeader = () => (
    <View style={getStyles(['widgetmainContainerHeaderContainer', 'subwidgetListHeaderContainer'])} id='widgetmainContainerHeaderContainer subwidgetListHeaderContainer'>
      {
        widget?.widgetHeaderImageUrl &&
        <ImageComp source={getCleanUrl(widget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'subwidgetListMainContainerImage'])} id="widgetmainContainerHeaderImg subwidgetListMainContainerImage" />
      }
      <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'subwidgetListHeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer subwidgetListHeaderTitleContainer'>
        {widget?.displayName &&
          <RenderHTML
            contentWidth={width}
            baseStyle={customWidgetTitleStyle}
            source={{ html: widget.displayName }}
            systemFonts={[customWidgetTitleStyle.fontFamily]}
            id='widgetmainContainerHeaderTitle subwidgetListHeaderTitle'
          />}
        {widget?.widgetDesc &&
          <RenderHTML
            contentWidth={width}
            baseStyle={customWidgetDescStyle}
            source={{ html: widget?.widgetDesc }}
            systemFonts={[customWidgetDescStyle.fontFamily]}
            id={`widgetmainContainerDesc subwidgetListMainContainerDesc subwidgetListMainContainerDesc_${widget?.id}`}
          />
        }
      </View>
    </View>
  )

  return (
    <View style={getStyles(['widgetRootContainer', 'subwidgetListRootContainer'])} id='widgetRootContainer subwidgetListRootContainer' >
      <HeaderWithBack />

      <ScrollView automaticallyAdjustContentInsets={true} showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['widgetmainContainer', 'subwidgetListMainContainer'])} id='widgetmainContainer subwidgetListMainContainer' >
        {renderHeader()}

        <View style={getStyles([
            'widgetmainContainerChildContainer', 
            'subwidgetListMainContainerChildContainer', 
            `subwidgetListMainContainerChildContainer_${listItemData?.[0]?.widgetMetaHtmlId}`
          ])}
          id={`widgetmainContainerChildContainer subwidgetListMainContainerChildContainer subwidgetListMainContainerChildContainer_${listItemData?.[0]?.widgetMetaHtmlId}`}
        >
          {listItemData.map(renderItem)}
        </View>
      </ScrollView>
    </View>
  );
};


export default React.memo(SubWidgetList);
